import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "signup.title",
    },
    email: {
        id: "account.email",
    },
    password: {
        id: "account.password",
    },
    passwordAgain: {
        id: "account.passwordAgain",
    },
    submit: {
        id: "signup.submit",
    },
    continueWithFacebook: {
        id: "signup.continueWithFacebook",
    },
    facebookConnecting: {
        id: "signup.facebookConnecting",
    },
    googleConnecting: {
        id: "signup.facebookConnecting",
    },
    continueWithGoogle: {
        id: "signup.continueWithGoogle",
    },
    acceptTerms: {
        id: "signup.acceptTerms",
    },
    acceptTermsMemory: {
        id: "memory.signup.acceptTerms",
    },
    withEmail: {
        id: "signup.withEmail",
    },
    withSocial: {
        id: "signup.withSocial",
    },
    submitInProgress: {
        id: "signup.submit.inprogress",
    },
});

export default messages;
